<template>
    <el-dialog :visible.sync="visible" title="新增收款记录"
               :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form :model="dataForm" ref="dataForm" label-width="120px">
            <el-row>
                <el-col :span="8">
                    <el-form-item label-width="100px" label="项目部：">
                        <el-select v-model="dataForm.projectDeptId" placeholder="请选择项目部" @change="getProjectList">
                            <el-option :label="deptItem.applyDeptName" :value="deptItem.applyDeptId" v-for="(deptItem,deptIndex) in deptList" :key="'deptItem'+deptIndex"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label-width="100px" label="项目名称：">
                        <el-select v-model="dataForm.projectId" placeholder="请选择项目名称">
                            <el-option :label="projectItem.name" :value="projectItem.id" v-for="(projectItem,projectIndex) in projectList" :key="'projectItem'+projectIndex"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label-width="100px" label="收款金额：" prop="name">
                        <el-input v-model="dataForm.receiptPrice" placeholder="请输入收款金额" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="16">
                    <el-form-item label-width="100px" label="申请日期：" prop="name">
                        <el-date-picker
                                v-model="applyTime"
                                type="daterange"
                                unlink-panels
                                value-format="yyyy-MM-dd HH:mm:ss"
                                range-separator="---"
                                start-placeholder="请选择开始时间"
                                end-placeholder="请选择结束时间"
                                :default-time="['00:00:00', '23:59:59']">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="16">
                    <el-form-item label-width="100px" label="批复日期：" prop="name">
                        <el-date-picker
                                v-model="replyTime"
                                type="daterange"
                                unlink-panels
                                value-format="yyyy-MM-dd HH:mm:ss"
                                range-separator="---"
                                start-placeholder="请选择开始时间"
                                end-placeholder="请选择结束时间"
                                :default-time="['00:00:00', '23:59:59']">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label-width="30px" class="btnList">
                        <el-button type="primary" @click="query()">查 询</el-button>
                        <el-button type="info" @click="reset()">重 置</el-button>
                    </el-form-item>
                </el-col>
            </el-row>

        </el-form>
        <div ref="main">
            <el-table
                    ref="dataTable"
                    :data="invoiceList"
                    highlight-current-row
                    @selection-change="handleSelectionChange"
                    @row-click="rowClicked"
                    size="mini"
                    height="390px"
                    border
            >
                <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
                <el-table-column
                        label="序号"
                        type="index"
                        width="50"
                ></el-table-column>
                <el-table-column
                        prop="projectDeptName"
                        label="项目部"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="projectName"
                        label="项目名称"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="number"
                        label="期数"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="contractPrice"
                        label="合同金额"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="finishPrice"
                        width="100"
                        label="完成产值"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="calculatePrice"
                        width="100"
                        label="计量金额"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="applyTime"
                        label="申请日期"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="replyPrice"
                        label="批复金额"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="replyTime"
                        label="批复时间"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="outputTaxPrice"
                        label="销项税金额"
                        :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                        prop="receiptPrice"
                        label="收款金额"
                        :show-overflow-tooltip="true"
                ></el-table-column>
            </el-table>
            <el-footer>
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="dataForm.pageIndex"
                        :page-sizes="[10, 20, 30, 50, 100]"
                        :page-size="dataForm.pageSize"
                        layout="total, prev, pager, next, sizes, jumper"
                        :total="total"
                ></el-pagination>
            </el-footer>
        </div>
        <el-footer class="container">
            <div class="btnMid">
                <el-button type="primary" @click="submitBtn()">保 存</el-button>
                <el-button type="info" @click="visible = false">取 消</el-button>
            </div>
        </el-footer>
    </el-dialog>
</template>

<script>
    import {
        getDeptListService,
        getProjectListService,
        getReceiptsItemsListService,
    } from '@/services/invoiceServices'
    export default {
        name: "confirm-addCollection",
        data(){
            return {
                visible: false,
                dataForm:{
                    projectDeptId:'',
                    projectId:'',
                    receiptPrice:'',
                    pageIndex: 1,
                    pageSize: 10,
                },
                total: 0,
                applyTime:[],
                replyTime:[],
                deptList:[], //项目部列表
                projectList:[], //项目列表
                invoiceList:[], //表格数据列表
                selectItems:[], //选中的列表
            }
        },
        mounted() {
        },
        methods: {
            init () {
                this.visible = true
                this.$nextTick(() => {
                    this.$refs['dataForm'].resetFields();
                    this.getReceiptsList();
                    this.getDeptList();
                })
            },
            // 查询
            query(){
                if(this.applyTime){
                    this.dataForm.applyTimeStart = this.applyTime[0];
                    this.dataForm.applyTimeEnd = this.applyTime[1];
                }else{
                    this.dataForm.applyTimeStart = '';
                    this.dataForm.applyTimeEnd = '';
                }
                if(this.replyTime){
                    this.dataForm.replyTimeStart = this.replyTime[0];
                    this.dataForm.replyTimeEnd = this.replyTime[1];
                }else{
                    this.dataForm.replyTimeStart = '';
                    this.dataForm.replyTimeEnd = '';
                }
                this.getReceiptsList();
            },
            reset(){
                this.dataForm = {
                    projectDeptId:'',
                    projectId:'',
                    receiptPrice:'',
                    applyTime:[],
                    replyTime:[],
                    pageIndex: 1,
                    pageSize: 10,
                }
                this.applyTime= []
                this.replyTime= []
                this.getReceiptsList();
            },
            // 获取数据
            getReceiptsList(){
                let paramsData = {
                    ...this.dataForm
                }
                getReceiptsItemsListService(paramsData).then( res => {
                    if(res.code == 10000000){
                        console.log(res)
                        this.invoiceList = res.data;
                        this.total = res.total;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /**
             *  获取项目部列表
             * */
            getDeptList(){
                getDeptListService().then( res => {
                    if(res.code == 10000000){
                        this.deptList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /**
             *  获取项目列表
             * */
            getProjectList(){
                this.dataForm.projectId = '';
                let paramsData = {
                    deptId: this.dataForm.projectDeptId
                }
                getProjectListService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.projectList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            // 保存按钮
            submitBtn(){
                this.visible = false
                this.$emit('refreshDataList', this.selectItems)
            },
            // 列代表多选回调
            handleSelectionChange(val) {
                this.selectItems = val;
            },
            // 点击选中行
            rowClicked(row, event, column) {
                this.$refs.dataTable.toggleRowSelection(row);
            },
            // 分页改变事件
            handleCurrentChange(page) {
                this.dataForm.pageIndex = page;
                this.getReceiptsList();
            },
            // 分页显示数量改变事件
            handleSizeChange(rows) {
                this.dataForm.pageIndex = 1;
                this.dataForm.pageSize = rows;
                this.getReceiptsList();
            },
        }
    }
</script>

<style scoped lang="scss">
    /deep/.el-dialog{
        width: 70%;
    }
    .container{
        width: 100%;
        margin-top: 60px;
        display: flex;
        justify-content: center;
    }
</style>
